"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Offset = void 0;
const Modifier_1 = require("./Modifier");
/**
 * Takes a part of the buffer
 *
 * @category Modifiers
 * @class Offset
 * @extends {Modifier}
 */
class Offset extends Modifier_1.Modifier {
    constructor(args = { from: 0, to: undefined }) {
        super();
        this.from = args.from;
        this.to = args.to;
    }
    apply(buffer, bClosed) {
        return buffer.subarray(this.from, this.to ? (this.to < 0 ? buffer.length + this.to : this.to) : undefined);
    }
}
exports.Offset = Offset;
//# sourceMappingURL=Offset.js.map